export default {
  SET_GRID_DATA_ACCKEY_LIST(state, params) {
    console.log(params);
    state.gridData = params;
  },

  SET_PROJECT_LIST_ACCKEY_LIST(state, params) {
    state.projectList = params;
  },

  SET_COLUMN_HEADER_LIST_ACCKEY_LIST(state, params) {
    state.columnHeaderList = params;
  },

  SET_COLUMN_NAME_LIST_ACCKEY_LIST(state, params) {
    state.columnNameList = params;
  },

  SET_SEARCH_PARAM_ACCKEY_LIST(state, params) {
    state.searchParam = params;
  },
};



// WEBPACK FOOTER //
// ./src/vuex/accKey/list/accKeyListMutation.js